import type { EnglishIqDailyTargetMinutesType } from '@repo/config';
import { saveEnglishIqPlanV1Api } from '@repo/sdk';
import { requireEnglishIqResponseData } from '../../actions/require-english-iq-response-data';

interface ISaveEnglishIqV2PlanParams {
  dailyTargetMinutes: EnglishIqDailyTargetMinutesType;
  shareId: string;
  visitorId: string;
}

export async function saveEnglishIqV2Plan(params: ISaveEnglishIqV2PlanParams) {
  const response = await saveEnglishIqPlanV1Api(params);
  return requireEnglishIqResponseData(response.data.data);
}
